module.exports = __webpack_public_path__ + "img/button_autoSpin.2f866849.png";